/* Veilleuse Douce Nuit — configurateur. Monté sur chaque [data-dn] de la page.
   Calques pleine taille dans le repère 600 du disque : lune (+ étoiles + nuage), animal, nuage de devant, prénom. */
(function(){
  function init(root){
  if(root.dataset.dnPret) return; root.dataset.dnPret='1';
  var BASE=root.dataset.base, VERSION_IMAGES='1';
  var NOM={size:52.9,max:250,couleur:'#422822',vide:'#9b8a84'};
  var LUNES=[{id:'rose',n:'Rose'},{id:'bleu',n:'Bleue'},{id:'beige',n:'Beige'},{id:'sauge',n:'Sauge'}];
  var ANIMAUX=[['ours','Ourson'],['lapin','Lapin'],['elephant','Éléphant'],['licorne','Licorne'],['renard','Renard'],['panda','Panda'],['mouton','Mouton'],['koala','Koala']];
  var etat={lune:'rose',animal:'ours',prenom:''};
  var APERCU=root.querySelector('.vn__apercu');
  function $(s){return root.querySelector(s)||APERCU.querySelector(s)}
  function img(id){return BASE+'dn-'+id+'.webp?v='+VERSION_IMAGES}
  function trouve(liste,id,cle){return liste.filter(function(x){return (cle?x[cle]:x[0])===id})[0]}

  $('[data-dn-photo]').setAttribute('href',img('photo'));
  $('[data-dn-lunes]').innerHTML=LUNES.map(function(l){return '<button type="button" role="radio" data-lune="'+l.id+'" aria-label="Lune '+l.n+'"><img src="'+img('lune-'+l.id+'-mini')+'" alt="" width="80" height="70" loading="lazy">'+l.n+'</button>'}).join('');
  $('[data-dn-animaux]').innerHTML=ANIMAUX.map(function(a){return '<button type="button" role="radio" data-animal="'+a[0]+'" aria-label="'+a[1]+'"><img src="'+img(a[0]+'-mini')+'" alt="" width="90" height="60" loading="lazy"><span>'+a[1]+'</span></button>'}).join('');
  // précharge les calques pour que le changement soit instantané
  setTimeout(function(){LUNES.forEach(function(l){new Image().src=img('lune-'+l.id);new Image().src=img('nuage-'+l.id)});ANIMAUX.forEach(function(a){new Image().src=img(a[0])})},1500);

  function ajusterNom(){
    var t=$('[data-dn-nom]');t.setAttribute('font-size',NOM.size);
    try{var w=t.getComputedTextLength();if(w>NOM.max)t.setAttribute('font-size',(NOM.size*NOM.max/w).toFixed(1))}catch(e){}
  }
  function rendu(){
    var lu=trouve(LUNES,etat.lune,'id'), an=trouve(ANIMAUX,etat.animal);
    root.querySelectorAll('[data-lune]').forEach(function(b){b.setAttribute('aria-checked',b.dataset.lune===etat.lune)});
    root.querySelectorAll('[data-animal]').forEach(function(b){b.setAttribute('aria-checked',b.dataset.animal===etat.animal)});
    $('[data-dn-val-lune]').textContent=lu.n; $('[data-dn-val-animal]').textContent=an[1];
    var reste=13-Array.from(etat.prenom).length; $('[data-dn-compteur]').textContent=reste+(reste>1?' restants':' restant');
    $('[data-dn-lune]').setAttribute('href',img('lune-'+lu.id)); $('[data-dn-nuage]').setAttribute('href',img('nuage-'+lu.id)); $('[data-dn-animal]').setAttribute('href',img(an[0]));
    var n=$('[data-dn-nom]'); n.textContent=etat.prenom||'Prénom'; n.setAttribute('fill',etat.prenom?NOM.couleur:NOM.vide); ajusterNom();
    $('[data-dn-p-lune]').value=lu.n; $('[data-dn-p-animal]').value=an[1]; $('[data-dn-p-prenom]').value=etat.prenom;
  }
  root.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b||!root.contains(b)) return;
    if(b.dataset.lune) etat.lune=b.dataset.lune; else if(b.dataset.animal) etat.animal=b.dataset.animal; else return;
    rendu(); montrerApercu();
  });
  $('[data-dn-prenom]').addEventListener('input',function(e){
    var v=e.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿŒœ' \-]/g,'').replace(/\s{2,}/g,' ');
    v=Array.from(v).slice(0,13).join(''); if(v!==e.target.value) e.target.value=v;
    etat.prenom=v.trim(); $('[data-dn-erreur]').hidden=true; rendu(); montrerApercu();
  });

  // option ajoutée au panier avec la veilleuse : adaptateur secteur USB
  var OPTION={handle:'adaptateur-usb-prise-secteur-220v',variante:47304866333003,prixNum:4.49};
  var caseOpt=$('[data-dn-option]'), blocOption=caseOpt.closest('.vn__carte'), prixOption=blocOption.querySelector('em');
  var prixBase=null;
  function lirePrix(t){var m=String(t||'').replace(/\s/g,'').match(/(\d+)[.,](\d{2})/);return m?parseFloat(m[1]+'.'+m[2]):null}
  function majPrixBouton(){
    var cibles=document.querySelectorAll('.kp-btn-prix'); if(!cibles.length) return;
    if(prixBase===null) prixBase=lirePrix(cibles[0].textContent); if(prixBase===null) return;
    var txt=(prixBase+(caseOpt.checked?OPTION.prixNum:0)).toFixed(2).replace('.',',')+' €';
    [].forEach.call(cibles,function(c){if(c.textContent!==txt) c.textContent=txt});
  }
  caseOpt.addEventListener('change',majPrixBouton);
  new MutationObserver(function(){majPrixBouton()}).observe(document.body,{childList:true,subtree:true,characterData:true});
  var vignette=document.createElement('img'); vignette.alt=''; vignette.width=48; vignette.height=48;
  vignette.setAttribute('style','width:48px;height:48px;object-fit:contain;border-radius:6px;background:#fff;flex:none;display:none');
  blocOption.insertBefore(vignette,blocOption.children[1]);
  fetch('/products/'+OPTION.handle+'.js').then(function(r){return r.json()}).then(function(p){
    var v=(p.variants||[]).filter(function(x){return x.id===OPTION.variante})[0]||p.variants[0];
    if(v){OPTION.variante=v.id; OPTION.prixNum=v.price/100; prixOption.textContent='+'+(v.price/100).toFixed(2).replace('.',',')+' €'; if(!v.available){blocOption.style.display='none';caseOpt.checked=false} majPrixBouton()}
    if(p.featured_image){vignette.src=p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_96x96$1$2'); vignette.style.display=''}
  }).catch(function(){});

  // s'installe dans le formulaire produit, juste avant le bouton d'ajout au panier
  var form=document.querySelector('form[data-product-form]')||document.querySelector('form[action*="/cart/add"]');
  if(form){
    var cible=form.querySelector('.product-single__add-to-cart');
    if(cible) cible.parentNode.insertBefore(root,cible); else form.appendChild(root);
  }

  // l'aperçu prend la place de la première photo du carrousel
  var apercu=APERCU, svg=apercu.querySelector('svg'), galerie=null;
  var media=document.querySelector('.product-single__media-group .product-single__media-wrapper .product--wrapper')||document.querySelector('.product-single__media-group .product-single__media');
  if(media){
    if(getComputedStyle(media).position==='static') media.style.position='relative';
    media.appendChild(apercu); apercu.classList.add('vn__apercu--galerie');
    galerie=media.closest('.product-single__media-wrapper')||media;
    var note=root.querySelector('.vn__note'); if(note) note.hidden=true;
  }
  function montrerApercu(){
    if(!galerie) return;
    var slider=galerie.closest('.slick-slider'), jq=window.jQuery;
    if(slider&&jq&&jq.fn&&jq.fn.slick){
      var $s=jq(slider), idx=jq(galerie).closest('.slick-slide').data('slick-index')||0;
      if($s.slick('slickCurrentSlide')!==idx) $s.slick('slickGoTo',idx);
      return;
    }
    if(galerie.offsetParent!==null) return;
    var id=(galerie.id||'').split('-').pop();
    var v=id&&document.querySelector('[data-thumbnail-id$="'+id+'"],[data-media-id$="'+id+'"],[href*="'+id+'"]');
    if(v) v.click();
  }

  // mobile : aperçu fixé en haut de l'écran pendant le choix des options
  var sceneId='dnScene-'+Math.random().toString(36).slice(2,8), scene=document.createElementNS('http://www.w3.org/2000/svg','g');
  scene.setAttribute('id',sceneId);
  Array.prototype.slice.call(svg.childNodes).forEach(function(n){if(n.nodeName!=='defs') scene.appendChild(n)});
  svg.appendChild(scene);
  var flot=document.createElement('div'); flot.className='vn-flottant'; flot.setAttribute('aria-hidden','true');
  flot.innerHTML='<div class="vn-flottant__vue"><svg viewBox="0 0 600 600"><use href="#'+sceneId+'"/></svg></div>';
  document.body.appendChild(flot);
  var ZOOMS=[1,1.4,1.8], niveauZoom=0, vue=flot.querySelector('svg'), groupeZoom=document.createElement('div');
  var LOUPE='<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/>';
  groupeZoom.className='vn-zoom';
  groupeZoom.innerHTML='<button type="button" data-zoom="1" aria-label="Zoomer sur l\'aperçu">'+LOUPE+'<path d="M10.5 7.5v6M7.5 10.5h6"/></svg></button>'
    +'<button type="button" data-zoom="-1" aria-label="Dézoomer l\'aperçu">'+LOUPE+'<path d="M7.5 10.5h6"/></svg></button>';
  groupeZoom.addEventListener('click',function(e){var b=e.target.closest('[data-zoom]');if(!b)return;e.preventDefault();e.stopPropagation();
    niveauZoom=Math.max(0,Math.min(ZOOMS.length-1,niveauZoom+(+b.dataset.zoom)));appliquerZoom()});
  flot.appendChild(groupeZoom);
  function appliquerZoom(){
    var z=ZOOMS[niveauZoom]; vue.style.transformOrigin='51.7% 50%'; vue.style.transform=z===1?'':'scale('+z+')';
    groupeZoom.querySelector('[data-zoom="1"]').disabled=niveauZoom===ZOOMS.length-1; groupeZoom.querySelector('[data-zoom="-1"]').disabled=niveauZoom===0;
  }
  appliquerZoom();
  var zonePanier=form&&form.querySelector('.product-single__add-to-cart');
  function majFlottant(){
    if(window.innerWidth>768){flot.classList.remove('is-visible');return}
    var h=flot.offsetHeight||300, a=apercu.getBoundingClientRect(), p=(zonePanier||root).getBoundingClientRect();
    flot.classList.toggle('is-visible', a.bottom<=h && p.bottom>h);
  }
  window.addEventListener('scroll',majFlottant,{passive:true}); window.addEventListener('resize',majFlottant);

  // contrôle avant l'ajout au panier (bouton principal et barre collante)
  var optionAjoutee=false;
  function boutonAjout(t){return t.closest&&t.closest('button[name="add"], .btn--add-to-cart, [data-sticky-addtocart], .dbtfy-sticky-addtocart button')}
  document.addEventListener('click',function(e){
    var b=boutonAjout(e.target); if(!b) return;
    if(!etat.prenom){
      e.preventDefault(); e.stopImmediatePropagation();
      $('[data-dn-erreur]').hidden=false; $('[data-dn-prenom]').focus();
      root.scrollIntoView({behavior:'smooth',block:'center'}); return;
    }
    if(caseOpt.checked&&!optionAjoutee){
      e.preventDefault(); e.stopImmediatePropagation();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(OPTION.variante),quantity:1}]})})
        .then(function(){optionAjoutee=true;b.click()})
        .catch(function(){optionAjoutee=true;b.click()});
    }
  },true);
  if(form) form.addEventListener('submit',function(e){
    if(!etat.prenom){e.preventDefault();e.stopImmediatePropagation();$('[data-dn-erreur]').hidden=false;$('[data-dn-prenom]').focus()}
  },true);

  // ordinateur : bouton « Voir l'aperçu » qui ouvre l'aperçu en grand
  var champPrenom=root.querySelector('.vn__prenom'), voir=document.createElement('button');
  voir.type='button'; voir.className='vn__voir'; voir.textContent='Voir l\'aperçu de ma veilleuse';
  champPrenom.parentNode.insertBefore(voir,champPrenom.nextSibling);
  var fen=document.createElement('div'); fen.className='vn-fenetre'; fen.hidden=true;
  fen.setAttribute('role','dialog'); fen.setAttribute('aria-modal','true'); fen.setAttribute('aria-label','Aperçu de votre veilleuse');
  fen.innerHTML='<div class="vn-fenetre__boite"><button type="button" class="vn-fenetre__fermer" aria-label="Fermer">&times;</button>'
    +'<svg viewBox="0 0 600 600"><use href="#'+sceneId+'"/></svg><p class="vn-fenetre__texte"></p></div>';
  document.body.appendChild(fen);
  function ouvrirFen(){
    var lu=trouve(LUNES,etat.lune,'id'), an=trouve(ANIMAUX,etat.animal);
    fen.querySelector('.vn-fenetre__texte').textContent='Lune '+lu.n+' · '+an[1]+(etat.prenom?' · '+etat.prenom:'');
    fen.hidden=false; fen.querySelector('.vn-fenetre__fermer').focus();
  }
  function fermerFen(){fen.hidden=true; voir.focus()}
  voir.addEventListener('click',ouvrirFen);
  fen.addEventListener('click',function(e){if(e.target===fen||e.target.closest('.vn-fenetre__fermer')) fermerFen()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!fen.hidden) fermerFen()});

  // vignettes du panier (script commun aux veilleuses)
  if(!window.vnPanier){var sp=document.createElement('script'); sp.src=BASE+'vn-veilleuse-panier.js?v=h'+Math.floor(Date.now()/36e5); sp.defer=true; document.head.appendChild(sp)}

  rendu(); majFlottant(); majPrixBouton();
  if(document.fonts&&document.fonts.load) document.fonts.load('700 52px "Dancing Script"').then(ajusterNom,ajusterNom);
  }
  function go(){document.querySelectorAll('[data-dn]').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
})();
